
export default function(
    parent,
    leaf,
)
{
    const space = parent.child( "help" );
    
    const $show = parent.s( "info" );
    const $hide = parent.s( "helpExit" );
    const $next = parent.s( "helpNext" );
    const $previous = parent.s( "helpPrevious" );
    
    $show
        .map( () => true )
        .merge( $hide.map( () => false ) )
        .subscribe( parent.s( "isHelp", false ) );
    
    
    const $paged = space.s( "paged" );
    
    const $pageNumber = space.s( "pageNumber" );
    
    $show
        .withLatestFrom( parent.s( "betValue" ), ( s, betValue ) => betValue )
        .subscribe( betValue =>
        {
            $pageNumber.next( 0 );
            leaf.show( betValue );
        } );
    
    $hide.subscribe( () => leaf.hide() );
    
    $next
        .withLatestFrom( $pageNumber, ( n, pageNumber ) => pageNumber )
        .map( pageNumber => pageNumber + 1 )
        .subscribe( $pageNumber );
    $previous
        .withLatestFrom( $pageNumber, ( n, pageNumber ) => pageNumber )
        .map( pageNumber => pageNumber - 1 )
        .subscribe( $pageNumber );
    
    $next.subscribe( () => leaf.nextPage( () => $paged.next() ) );
    $previous.subscribe( () => leaf.previousPage( () => $paged.next() ) );
    
    $next
        .map( () => true )
        .merge( $previous.map( () => true ) )
        .merge( $paged.map( () => false ) )
        .subscribe( parent.s( "helpPaging", false ) );
    
    $pageNumber
        .map( pageNumber => pageNumber < leaf.getPagesCount() - 1 )
        .subscribe( parent.s( "helpCanNext" ) );
    $pageNumber
        .map( pageNumber => pageNumber > 0 )
        .subscribe( parent.s( "helpCanPrevious" ) );
}




// WEBPACK FOOTER //
// ./src/library/help.es6